export enum FeaturesSectionURL {
  HOSTING = '#hosting',
  ANALYTICS = '#analytics',
  MONETIZATION = '#monetization',
  CREATION = '#creation',
}

/**
 * The values here are picked to be backwards-compatible with the previous
 * version of the incoming links from the Home page (for analytics continuity).
 */
export enum FeaturesSectionAnalyticsName {
  ANALYTICS = 'analytics',
  CREATION = 'tools',
  HOSTING = 'distribution',
  MONETIZATION = 'monetization',
}
